<template>
  <div class="module-navigation-edit relative">
    <menu-item label="功能设置">
      <menu-switch v-model="model.enabled" class="mt-4" label="是否开启模块导航" />
    </menu-item>
    <template v-if="model.enabled">
      <menu-item label="面板背景">
        <menu-fill :target="model.background" target-key="background" />
        <menu-background-image class="mt-2" :target="model.background" target-key="background" />
      </menu-item>
      <menu-item label="选中颜色">
        <menu-fill :target="model.activeColor" target-key="activeColor" solid-color />
      </menu-item>
      <menu-item label="未选中颜色">
        <menu-fill :target="model.inactiveColor" target-key="inactiveColor" solid-color />
      </menu-item>
      <menu-item label="ICON">
        <menu-background-image :target="model.icon" target-key="icon" />
      </menu-item>
    </template>
  </div>
</template>

<script>
import MenuItem from "~/components/menu/menuItem.vue";
import MenuFill from "~/components/menu/menuFill.vue";
import MenuBackgroundImage from "~/components/menu/menuBackgroundImage.vue";
import MenuSwitch from "~/components/menu/menuSwitch.vue";

export default {
  name: "ModuleNavigationEdit",
  components: { MenuSwitch, MenuBackgroundImage, MenuFill, MenuItem },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped lang="less">
</style>
